const propertiesApi = ({ apiClient }) => ({
  /**
   *
   * @param params
   * @returns {*}
   */
  list(params, headers = {}) {
    return apiClient.get('properties', {}, params, headers)
  },

  show(id, param = {}, headers = {}) {
    return apiClient.get(`properties/${id}`, {}, param, headers)
  },

  update(id, params, headers = {}) {
    return apiClient.put(`properties/${id}`, params, headers)
  },

  types() {
    return apiClient.get('properties/types')
  },

  options() {
    return apiClient.get('properties/options')
  },

  /**
   *
   * @param code
   * @returns {*}
   */
  syncByCode(code, headers = {}) {
    if (!code) throw new Error('Código não informado', headers)

    return apiClient.get(`properties/sync-by-code/${code}`)
  },
  // erp pode ser retornado na rota /me
  /**
   *
   * @param code
   * @param erp
   * @returns {*}
   */
  compareErpByCode(code, erp, headers = {}) {
    if (!code) throw new Error('Código não informado', headers)

    return apiClient.get(`properties/compare-erp-by-code/${code}`)
  },
})

export default propertiesApi
